/**
 * 「我的小组件」的视觉:用户存的组件没有作者画的缩略图,用名字首字的字母牌
 * 顶上——底色按 id 稳定取自图表配色,深浅主题都由 token 兜住。画廊与模板页共用。
 */
const ACCENTS = [
  'var(--xuwo-chart-blue, #3b82f6)',
  'var(--xuwo-chart-green, #22c55e)',
  'var(--xuwo-chart-purple, #a855f7)',
  'var(--xuwo-chart-orange, #f97316)',
  'var(--xuwo-chart-red, #ef4444)',
  'var(--xuwo-chart-brown, #14b8a6)',
  'var(--xuwo-chart-pink, #ec4899)',
  'var(--xuwo-chart-yellow, #eab308)',
];

export function libraryAccent(id: string): string {
  let hash = 0;
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) | 0;
  return ACCENTS[Math.abs(hash) % ACCENTS.length];
}

/** 名字的第一个「字」:中文取首字,英文取首个单词的首字母大写。 */
export function libraryMonogram(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const first = [...trimmed][0] ?? '?';
  return /[a-z]/i.test(first) ? first.toUpperCase() : first;
}

/** 字母牌本身:行内 SVG,与模板缩略图同一个 96×60 画布,便于并排。 */
export function libraryThumbnail(_id: string, name: string): string {
  const letter = libraryMonogram(name).replace(/[<>&"]/g, '');
  return `<svg viewBox="0 0 96 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="8" width="80" height="44" rx="8" fill="currentColor" fill-opacity=".12"/><rect x="14" y="14" width="26" height="6" rx="3" fill="currentColor" fill-opacity=".35"/><rect x="14" y="40" width="44" height="5" rx="2.5" fill="currentColor" fill-opacity=".2"/><text x="72" y="40" text-anchor="middle" font-family="ui-sans-serif, system-ui, -apple-system, 'PingFang SC', sans-serif" font-size="22" font-weight="700" fill="currentColor" fill-opacity=".85">${letter}</text></svg>`;
}

export { libraryAccent as widgetLibraryAccent };
